import React from 'react'

const SelectTickIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.998 1.99219C6.48405 1.99319 1.99805 6.47919 1.99805 11.9932C1.99805 17.5072 6.48405 21.9932 11.999 21.9932C17.512 21.9932 21.998 17.5072 21.999 11.9932C22 6.47919 17.513 1.99319 11.998 1.99219ZM11.999 19.9932C7.58705 19.9932 3.99805 16.4042 3.99805 11.9932C3.99805 7.58219 7.58705 3.99319 11.998 3.99219C16.41 3.99319 19.999 7.58219 19.999 11.9932C19.998 16.4042 16.409 19.9932 11.999 19.9932Z" fill="#0FB680"/>
    <path d="M12 10.9952H8V12.9952H12V16.0012L16.005 11.9962L12 7.99219V10.9952Z" fill="#0FB680"/>
    </svg>
    
  )
}

export default SelectTickIcon
